module.exports = {
  title: 'GitHub Contributions with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2025-07-29',
  slug: 'github-contributions',
  tags: ['reanimated'],
};
